const LOADER_SELECTOR = 'data-infinite-loader'
const LOADER_TRIGGER = 'data-infinite-loader-trigger'
const LOADER_ITEM_HIDDEN = 'data-infinite-loader-item-hidden'
const DRUPAL_INFINITE_BUTTON = 'data-button-infinite-scroll'

function init(){
  const loaders = document.querySelectorAll(`[${LOADER_SELECTOR}]`)
  const infiniteScrollButton = document.querySelectorAll(`[${DRUPAL_INFINITE_BUTTON}]`)
  if (infiniteScrollButton.length) {
    initInfiniteScrollers(infiniteScrollButton);
  }
  if (loaders.length) {
    initLoaders(loaders)
  }
}

function initLoaders(loaders) {
  loaders.forEach(loader => {
    const trigger = loader.querySelector(`[${LOADER_TRIGGER}]`)
    const nbOfItemsToShow = parseInt(loader.getAttribute(LOADER_SELECTOR), 10);

    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      const items = loader.querySelectorAll(`[${LOADER_ITEM_HIDDEN}]`)
      showMore(trigger, nbOfItemsToShow, items)
    })
  })
}

function initInfiniteScrollers (buttons) {
  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
    })
  })
}

function showMore(trigger, nbToShow, items) {
  if (nbToShow > items.length) {
    trigger.remove();
  }
  items.forEach((item, index) => {
    if (index < nbToShow) {
      item.classList.add('visible')
      item.removeAttribute(LOADER_ITEM_HIDDEN)
    }
  })
}


export default { init }
